<div class="modal-header">
  <h5 class="modal-title">
    <ng-container i18n *ngIf="isEdit">Edit Extra</ng-container>
    <ng-container i18n *ngIf="!isEdit">Add Extra</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div *ngIf="isDuplicate" class="mx-3 mt-3">
  <alert type="warning">
    <strong i18n>Warning:</strong>
    <ng-container i18n>This extra is a duplicate. Please modify the extra details, before clicking</ng-container>
    <strong i18n>Save</strong> <ng-container i18n>to create the extra.</ng-container>
  </alert>
</div>

<div class="modal-body">
  <ul class="nav top-navbar border-bottom mb-3" *ngIf="isEdit">
    <li [class.active]="activeTab === tabs.Extra">
      <a (click)="activeTab = tabs.Extra" i18n> Extra </a>
    </li>
    <li [class.active]="activeTab === tabs.Attributes">
      <a (click)="activeTab = tabs.Attributes" i18n> Custom Attributes </a>
    </li>
    <li [class.active]="activeTab === tabs.Comments">
      <a (click)="activeTab = tabs.Comments" i18n> Comments </a>
    </li>
    <li [class.active]="activeTab === tabs.Activity">
      <a (click)="activeTab = tabs.Activity" i18n> Logs </a>
    </li>
  </ul>
  <ng-container [ngSwitch]="activeTab">
    <ng-template *ngSwitchCase="tabs.Extra" [ngTemplateOutlet]="detailsForm"></ng-template>
    <ng-template *ngSwitchCase="tabs.Comments" [ngTemplateOutlet]="comments"></ng-template>
    <ng-template *ngSwitchCase="tabs.Activity" [ngTemplateOutlet]="activity"></ng-template>
    <div *ngSwitchCase="tabs.Attributes">
      <app-entity-attributes
        #attrs
        entityType="extras"
        [entityId]="extra.pkey"
        [showActions]="false"
      ></app-entity-attributes>
    </div>
  </ng-container>
</div>
<div class="modal-footer">
  <button
    *ngIf="isEdit && !extraCharge"
    (click)="onCharge()"
    [disabled]="(1 | isReadonlyRole) || !extra.inquiry_id"
    type="button"
    class="btn btn-secondary-warning"
    matTooltip="Please specify the inquiry before you can create charge"
    i18n-matTooltip
    [matTooltipDisabled]="!!extra.inquiry_id"
  >
    <span class="cs-icon cs-icon-card"></span>
    <ng-container i18n>Create Charge</ng-container>
  </button>
  <button *ngIf="isEdit && extraCharge" (click)="onViewCharge()" type="button" class="btn btn-secondary-warning">
    <span class="cs-icon cs-icon-card"></span>
    <ng-container i18n>Charge</ng-container>
  </button>
  <button class="btn btn-secondary-danger" (click)="onDelete()" *ngIf="isEdit">
    <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
  </button>

  <div class="flex-fill"></div>
  <button (click)="close()" type="button" class="btn btn-light">
    <span class="far fa-times"></span>
    <ng-container i18n>Cancel</ng-container>
  </button>
  <ng-container *ngIf="activeTab === tabs.Attributes && attrs">
    <button (click)="attrs.onConfig()" [disabled]="1 | isReadonlyRole" type="button" class="btn btn-secondary-primary">
      <span class="cs-icon cs-icon-cog"></span>
      <ng-container i18n>Attributes Configuration</ng-container>
    </button>
    <button
      (click)="onSaveAttrs()"
      [disabled]="(1 | isReadonlyRole) || attrs.isSaving"
      type="button"
      class="btn btn-secondary-info"
    >
      <i class="cs-icon cs-icon-save" *ngIf="!attrs.isSaving"></i>
      <i class="far fa-spin fa-spinner" *ngIf="attrs.isSaving"></i>
      <ng-container i18n>Save</ng-container>
    </button>
  </ng-container>
  <button
    *ngIf="activeTab !== tabs.Attributes"
    (click)="save(form)"
    [disabled]="1 | isReadonlyRole"
    type="button"
    class="btn btn-secondary-info"
  >
    <span class="cs-icon cs-icon-save"></span>
    <ng-container i18n>Save</ng-container>
  </button>
</div>

<ng-template #detailsForm>
  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="mb-3">
      <ng-template [ngTemplateOutlet]="attachmentsTmpl"></ng-template>
    </div>
    <div class="row">
      <div class="col-md-6">
        <app-rental-select
          [multiple]="false"
          [matTooltip]="getRentalTooltip()"
          matTooltipPosition="left"
          [ctrl]="form.get('rental_id')"
          placeholder="Rental"
          i18n-placeholder
          (selectedItemsChange)="onRentalChange($event)"
        >
        </app-rental-select>
      </div>
      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <input
            type="text"
            *ngIf="isEdit"
            matTooltip="Change the category or create a new one by deleting the existing data and typing into the field below."
            matTooltipPosition="left"
            i18n-matTooltip
            placeholder="Category"
            i18n-placeholder
            matInput
            [formControl]="form.get('category')"
            [matAutocomplete]="auto"
          />
          <input
            type="text"
            *ngIf="!isEdit"
            matTooltip="Choose a category or create a new one by typing into the field below."
            matTooltipPosition="left"
            i18n-matTooltip
            placeholder="Category"
            i18n-placeholder
            matInput
            [formControl]="form.get('category')"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let category of categories$ | async" [value]="category.value">
              {{ category.label }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="form.get('category').touched && form.get('category').hasError('required')">
            <ng-container i18n>Category is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <app-booking-select
          *ngIf="isEdit"
          tooltipText="Change the inquiry this extra is associated with."
          i18n-tooltipText
          [ctrl]="form.get('inquiry_id')"
          (selected)="onSelectInquiry($event)"
          [rentalId]="form.get('rental_id').value"
          [required]="true"
        ></app-booking-select>
        <app-booking-select
          *ngIf="!isEdit"
          tooltipText="Associate this extra with an inquiry."
          i18n-tooltipText
          [ctrl]="form.get('inquiry_id')"
          (selected)="onSelectInquiry($event)"
          [rentalId]="form.get('rental_id').value"
          [required]="true"
        ></app-booking-select>
      </div>
      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <input
            matInput
            [matDatepicker]="extraDate"
            placeholder="Date"
            i18n-placeholder
            [required]="true"
            (focus)="extraDate.open()"
            formControlName="date"
            readonly
          />
          <i matSuffix (click)="extraDate.open()" class="cs-icon cs-icon-calendar"></i>
          <mat-datepicker #extraDate></mat-datepicker>
          <mat-error *ngIf="form.get('date').touched && form.get('date').hasError('required')">
            <ng-container i18n>Date is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>

      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <input
            matInput
            decimal
            required
            placeholder="Amount"
            i18n-placeholder
            formControlName="amount"
            type="number"
          />
          <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')">
            <ng-container i18n>Amount is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="method" placeholder="Payment Method" i18n-placeholder>
            <mat-option *ngFor="let method of methodOptions" [value]="method.value">{{ method.name }}</mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
      <div class="col-md-6 mb-3">
        <mat-checkbox formControlName="status" i18n> Paid </mat-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 position-relative">
        <mat-form-field2 class="mat-block" cdkOverlayOrigin #aiSuggestionsTrigger="cdkOverlayOrigin">
          <textarea
            matInput
            formControlName="description"
            #notes
            maxlength="500"
            rows="3"
            placeholder="Description"
            i18n-placeholder
            cdkTextareaAutosize
          ></textarea>
          <mat-hint align="end">{{ notes.value?.length || 0 }}/500</mat-hint>
        </mat-form-field2>
        <app-ai-suggestions-icon
          *ngIf="isEdit"
          [entityId]="extra.pkey"
          [length]="250"
          type="extra_description"
          [attachTo]="aiSuggestionsTrigger"
          [width]="aiSuggestionsTrigger.elementRef?.nativeElement.clientWidth"
          (apply)="form.get('description').setValue($event)"
          tooltipText="Generate suggestions for the extra description"
          i18n-tooltipText
          class="position-absolute"
          style="bottom: 2rem; right: 2rem"
        ></app-ai-suggestions-icon>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #comments>
  <app-comments-list entityType="extras" [entityId]="extra.pkey">
    <app-empty-table type="CommentsList"></app-empty-table>
  </app-comments-list>
</ng-template>

<ng-template #activity>
  <app-activity-table entityType="extras" [entityId]="extra.pkey">
    <app-empty-table type="ActivityList"></app-empty-table>
  </app-activity-table>
</ng-template>

<ng-template #attachmentsTmpl>
  <app-upload-box
    [options]="uploadBoxOptions"
    (complete)="onFileUploaded($event)"
    *ngIf="!attachments.length && !(1 | isReadonlyRole)"
    image="/assets/images/upload-formate2.png"
  ></app-upload-box>
  <div *ngFor="let item of attachments; let i = index" class="d-flex align-items-center gap-3">
    <div class="text-primary text-xxl">
      <i class="" [ngClass]="item.name | fileIcon"></i>
    </div>
    <div class="mr-4 text-truncate">{{ item.name }}</div>
    <div class="flex-fill text-light text-right text-sm">
      {{ item.created | epoch : 'DD-MMM-YYYY' }} at {{ item.created | epoch : 'HH:mm' }} • {{ item.user }} •
      {{ item.size | fileSize }}
    </div>
    <div class="d-flex">
      <a href="javascript:;" class="btn btn-light-info btn-sm" (click)="onDownloadAttachment(item)">
        <i class="cs-icon cs-icon-download"></i>
      </a>
      <a
        href="javascript:;"
        class="btn btn-light-danger btn-sm"
        (click)="onDeleteAttachment(item)"
        *ngIf="!(1 | isReadonlyRole)"
        ><i class="cs-icon cs-icon-trash"></i>
      </a>
    </div>
  </div>
</ng-template>
